import type {ReadyManifest} from '@wandb/weave/core';

/**
 * Given a patch file name, find the corresponding file in the artifact. This
 * process can be tricky, because if the user called `log_file` outside of the
 * root directory of the project, the logged files will be relative to that
 * directory instead of the root directory. So we need to try to find the file
 * in the artifact by trying to match the end of the file path, and if there are
 * multiple matches, we can try to find the one that is closest to the root
 * directory of the project.
 *
 * @param manifest the manifest of the artifact to search through.
 * @param fileName name of the file to find. If this is coming from a patch
 *                      file, it should have the `a/` or `b/` stripped before
 *                      calling this function.
 * @returns the path of the file in the artifact, or null if not found.
 */
export function locateFileInManifest(
  manifest: ReadyManifest,
  fileName: string
) {
  const candidates = Object.entries(manifest.manifest.contents).filter(
    ([path]) => fileName === path || fileName.endsWith('/' + path)
  );

  if (candidates.length === 0) {
    return null;
  } else {
    // find the candidate with the shortest path
    candidates.sort((a, b) => a[0].split('/').length - b[0].split('/').length);
    // QUESTION: warn if there are multiple candidates?
    return candidates[0][0];
  }
}
